import { INavigationItem } from '../models/navigation';
import {
    PermissionArea,
    QualityAssuranceModulePermissionFlag,
    InteractionModulePermissionFlag,
    DashboardModulePermissionFlag,
    AskMeModulePermissionFlag,
} from './permissions';

export const navigationItems: INavigationItem[] = [
    // Temporarily hiding workspace & library while Library is empty
    /*
    {
        to: '/workspace',
        text: 'workspace',
        icon: 'workspaces.svg',
        children: [
            {
                to: '/workspace/dashboard',
                text: 'dashboard',
                icon: 'dashboard.svg',
            },
            {
                to: '/workspace/library',
                text: 'library',
                icon: 'bookmark.svg',
            },
        ],
    },
    */
    {
        to: '/workspace/dashboard',
        text: 'dashboard',
        icon: 'dashboard.svg',
        permission: {
            area: PermissionArea.DashboardModule,
            flag: DashboardModulePermissionFlag.ViewDashboards,
        },
    },
    {
        to: '/interactions',
        text: 'interactions',
        icon: 'summarize.svg',
        permission: {
            area: PermissionArea.InteractionModule,
            flag: InteractionModulePermissionFlag.Access,
        },
    },
    {
        to: '/ask-me',
        text: 'ask-me',
        icon: 'chat.svg',
        permission: {
            area: PermissionArea.AskMeModule,
            flag: AskMeModulePermissionFlag.Access,
        },
    },
    {
        to: '/quality-assurance',
        text: 'quality-assurance',
        icon: 'group.svg',
        permission: {
            area: PermissionArea.QualityAssuranceModule,
            flag: QualityAssuranceModulePermissionFlag.Access,
        },
        children: [
            {
                to: '/quality-assurance/coaching',
                text: 'coaching',
                icon: 'check_circle.svg',
                permission: {
                    area: PermissionArea.QualityAssuranceModule,
                    flag: QualityAssuranceModulePermissionFlag.ManualCoaching,
                },
            },
            {
                to: '/quality-assurance/protocols',
                text: 'protocols',
                icon: 'protocol.svg',
            },
            {
                to: '/quality-assurance/organisational-results',
                text: 'organisational-results',
                icon: 'layers.svg',
            },
        ],
    },
];
